// extracted by mini-css-extract-plugin
module.exports = {"root":"SearchedProducts_root__1Ghlv","titleContainer":"SearchedProducts_titleContainer__1nxuz","loadingContainer":"SearchedProducts_loadingContainer__1ePDF"};